import { ThreadComm } from "threadcomm";
import { ZeneithDB } from "../ZeneithDB.js";
class SecureIDBWrap {
    id;
    data;
    static dbs = new Map();
    static clear(id) {
        const cdb = SecureIDBWrap.dbs.get(id);
        if (!cdb)
            return;
        cdb.close();
        SecureIDBWrap.dbs.delete(id);
    }
    connectionId = crypto.randomUUID();
    constructor(id, data) {
        this.id = id;
        this.data = data;
        if (SecureIDBWrap.dbs.get(id)) {
            const cdb = SecureIDBWrap.dbs.get(id);
            cdb.close();
        }
        SecureIDBWrap.dbs.set(this.id, data);
        ZeneithDB.core.dataBase.setData("meta", `${this.connectionId}-${id}`, {
            time: new Date().toLocaleTimeString(),
            dataBaseId: id,
            thread: {
                name: ThreadComm.threadName,
                number: ThreadComm.threadNumber,
                parent: ThreadComm.parent.name,
            },
        });
    }
    get() {
        return this.data;
    }
    null() {
        SecureIDBWrap.clear(this.id);
        ZeneithDB.core.dataBase.removeData("meta", `${this.connectionId}-${this.id}`);
    }
}
export { SecureIDBWrap };
